import { Navbar, Nav, NavDropdown } from 'react-bootstrap'

function Menu() {
  const elements = [
    {
        name: 'INÍCIO',
        path: '/',
        type: 'link'
    }, 
    // {
    //     name: 'DIRETORIA',
    //     path: '/diretoria',
    //     type: 'link'
    // }, 
    // {
    //     name: 'CONVENÇÕES COLETIVAS',
    //     path: '/convencoes-coletivas',
    //     type: 'link'
    // },
    {
        name: 'NOTÍCIAS',
        path: '/noticias',
        type: 'link'
    },
    {
        name: 'JORNAL',
        path: '/jornal',
        type: 'link'
    },
    // {
    //     name: 'ASSOCIE-SE',
    //     path: '/associe-se',
    //     type: 'link'
    // },
    // {
    //     name: 'BENEFÍCIOS',
    //     path: '/beneficios',
    //     type: 'link'
    // },
    // {
    //     name: 'JURÍDICO',
    //     path: '/juridico',
    //     type: 'link'
    // },
    // {
    //     name: 'JORNAL',
    //     path: '/jornal',
    //     type: 'link'
    // },
    // {
    //     name: 'CONTATO',
    //     path: '/contato',
    //     type: 'link'
    // },
  ]

  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="menu">
        <Nav className="mx-auto">
          {elements.map((element, index) => {
            if (element.type === 'link') {
              return (<Nav.Link key={index} href={element.path} style={{ color: '#FFF' }}>{element.name}</Nav.Link>)
            } else if (element.type === 'dropdown') {
              return (
                <NavDropdown title={element.name} id="basic-nav-dropdown" className="menu">
                  {
                    element.items.map((element, index) => (
                      <NavDropdown.Item href={element.path}>{element.name}</NavDropdown.Item>
                    ))
                  }
                </NavDropdown>
              )
            }
          })}
        </Nav>
      </Navbar.Collapse>
    </>
  );
}

export default Menu;
